export const shellsMinecraftBG = require("./shells_minecraft_bg.png");
export const heroText = require("./shells_minecraft_herotext.png");
